import React from "react";
import { withRouter } from "react-router-dom";

import Slider from "rc-slider";
import { defineGrid, extendHex, Point } from "honeycomb-grid";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup } from "aible";

import LeakageChart from "components/Next/Charts/LeakageChart";
import DistributionChart from "components/Next/Charts/DistributionChart";
import OutcomeChart from "components/Next/Charts/OutcomeChart";

import HexagonContainer from "containers/Next/Hexagon";

import { centerHex } from "containers/Next/NextReducer";

import styles from "./style.module.css";

export default class HexGrid extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      shouldZoom: true,
      shouldScroll: true,
      stopAnimation: false,
      shouldAnimate: true,
      endAnimation: false
    };

    this.animationTimer = setTimeout(() => {
      this.setState({ endAnimation: true });
      this.animationTimer = undefined;
    }, 5000);
  }

  componentWillUnmount() {
    if (this.animationTimer !== undefined) {
      clearTimeout(this.animationTimer);
    }
  }

  setZoom(zoomSize) {
    const { updateHexSize } = this.props;

    const { stopZoom } = this.state;

    if (stopZoom !== true) {
      updateHexSize(zoomSize);
      this.setState({ stopZoom: true });

      setTimeout(() => this.setState({ stopZoom: false }), 25);
    }
  }

  render() {
    const {
      id,
      dataset,
      rankedFields,
      hexSize,
      hexagonRadius,
      actionHexMap,
      hexMap,
      savedHexMap,
      innerHexSize,
      updateSelectedHex,
      mType,
      isMini,
      isPreview,
      dragHex,
      selectedHex,
      selectionDirection,
      isProjectOverview,
      isAnimateReturn,
      pinnedHexList,
      updateHover,
      activeTab
    } = this.props;
    const { chartType, isDistributrion, staticHexes, stopAnimation, shouldAnimate, endAnimation } = this.state;

    const rowColsCount = hexagonRadius * 2 + 1;

    const mainHeight = rowColsCount * innerHexSize + innerHexSize / 4;
    const mainWidth = rowColsCount * innerHexSize;

    const projectOverviewSize = 310;
    const miniHeightDelta = (isProjectOverview ? projectOverviewSize : 180) / mainHeight;
    const miniWidthDelta = (isProjectOverview ? projectOverviewSize : 240) / mainWidth;

    const hexGrid = [];
    const hexGridAction = [];
    const miniHexGrid = [];

    let existCounter = 0;

    const rHexMap = hexMap ? Object.keys(hexMap) : [];

    const allCharts = [];

    rHexMap.forEach((hKey) => {
      const nodes = hexMap[hKey];

      if (Array.isArray(nodes)) {
        nodes.forEach((n) => {
          allCharts.push(n);
        });
      } else {
        const retNode = {
          ...nodes,
          x: Number(hKey.split("_")?.[0]),
          y: Number(hKey.split("_")?.[1])
        };
        allCharts.push(retNode);
      }
    });

    savedHexMap !== undefined &&
      Object.keys(savedHexMap).forEach((hKey) => {
        const nodes = hexMap[hKey];

        if (Array.isArray(nodes)) {
          nodes.forEach((n) => {
            allCharts.push(n);
          });
        } else {
          allCharts.push(nodes);
        }
      });

    const Hex = extendHex({
      size: hexSize, // default: 1
      orientation: "flat" // default: 'pointy'
    });

    const Grid = defineGrid(Hex);

    Grid.hexagon({
      radius: hexagonRadius,
      center: [hexagonRadius, hexagonRadius]
    }).forEach((hex, i) => {
      const { x, y } = hex.toPoint();

      const hKey = hex.x + "_" + hex.y;

      const isExist =
        (hexMap && hexMap[hKey]) || (actionHexMap && actionHexMap[hKey]) || (savedHexMap && savedHexMap[hKey]);

      if (isExist && hKey !== "8_8") {
        existCounter++;
      }

      const aIndex = allCharts.indexOf(hKey);

      const node = hexMap?.[hKey];
    });

    const hasActionMap = Object.keys(actionHexMap).length > 0;

    let allLocs = {};

    allCharts.forEach((node) => {
      const hKey = node?.x + "_" + node?.y;

      if (allLocs[hKey] === undefined) {
        allLocs[hKey] = [];
      }

      allLocs[hKey].push(node);
    });

    let retSavedCharts = [];

    Object.keys(allLocs).forEach((hKey, locIndex) => {
      const nodes = allLocs[hKey];
      const node = nodes?.[0];

      const hex =
        node === undefined && hKey !== undefined
          ? Hex(hKey.split("_")?.[0], hKey.split("_")?.[1])
          : Hex(node?.x, node?.y);

      const { x, y } = hex.toPoint();

      const selNode = nodes.find(
        (n) => n?.chart?.narrative?.title && n?.chart?.narrative?.title === selectedHex?.chart?.narrative?.title
      );

      const isSelectedHex = selNode !== undefined;

      const isFadedHex = isSelectedHex !== true && hasActionMap && isAnimateReturn !== true;

      const isSemiFadedHex = isSelectedHex && selectionDirection !== undefined;

      const aIndex = pinnedHexList.findIndex(
        (pChart) => pChart?.chart?.narrative?.title === node?.chart?.narrative?.title
      );

      const miniHex = (
        <HexagonContainer
          id={id}
          key={hKey + "_" + locIndex}
          left={x * miniWidthDelta + "px"}
          top={y * miniHeightDelta + "px"}
          hex={hex}
          mType={mType}
          node={Array.isArray(node) === false ? node : node?.[node.length - 1]}
          nodes={Array.isArray(node) === true ? node : undefined}
          aTimeout={undefined}
          isPreview={isPreview}
          isMini
        />
      );

      miniHexGrid.push(miniHex);

      retSavedCharts.push(
        <div
          key={"base_" + hKey + "_" + locIndex + "_" + (nodes ? nodes.length : 0)}
          className={styles.oTrans}
          style={{
            opacity: isSemiFadedHex ? 0.5 : isFadedHex ? 0.2 : 1,
            pointerEvents: isSemiFadedHex || isFadedHex ? "none" : "all"
          }}
        >
          <HexagonContainer
            id={id}
            node={selNode ? selNode : node}
            nodes={nodes}
            left={x}
            top={y}
            hex={hex}
            pointToHex={(x, y) => Grid.pointToHex(Point(x, y))}
            getPoint={(x, y) => {
              return Hex(x, y).toPoint();
            }}
            aTimeout={
              endAnimation === true
                ? undefined
                : stopAnimation === true
                  ? undefined
                  : hKey === "8_8"
                    ? undefined
                    : aIndex * 500 + 1000
            }
          />
        </div>
      );
    });

    Object.keys(actionHexMap)
      .map((aKey) => ({
        x: Number(aKey.split("_")?.[0]),
        y: Number(aKey.split("_")?.[1]),
        isFromActionMap: true,
        isAction: true,
        ...actionHexMap[aKey]
      }))
      .filter((a) => true)
      .forEach((node, aIndex) => {
        const hKey = node?.x + "_" + node?.y;
        const hex = Hex(node?.x, node?.y);

        const { x, y } = hex.toPoint();

        const isSelectedHex =
          node?.chart?.narrative?.title && node?.chart?.narrative?.title === selectedHex?.chart?.narrative?.title;

        const miniHex = (
          <HexagonContainer
            id={id}
            key={hKey + "_mini_" + aIndex}
            left={x * miniWidthDelta + "px"}
            top={y * miniHeightDelta + "px"}
            hex={hex}
            mType={mType}
            node={Array.isArray(node) === false ? node : undefined}
            nodes={Array.isArray(node) === true ? node : undefined}
            isMini
            aTimeout={undefined}
            isPreview={isPreview}
          />
        );

        if (isAnimateReturn !== true) {
          miniHexGrid.push(miniHex);
        }

        const actionKey = node?.chart?.narrative?.title || node?.type || node?.x + "_" + node?.y;

        retSavedCharts.push(
          <div className={styles.aTrans} style={{ opacity: isAnimateReturn ? 0 : 1 }} key={"action_" + actionKey}>
            <HexagonContainer
              id={id}
              node={node}
              left={x}
              top={y}
              hex={hex}
              pointToHex={(x, y) => Grid.pointToHex(Point(x, y))}
              getPoint={(x, y) => {
                return Hex(x, y).toPoint();
              }}
              zIndex={isAnimateReturn ? 1 : 66}
            />
          </div>
        );
      });

    if (dragHex) {
      const dragPoint = Hex(dragHex.x, dragHex.y).toPoint();

      retSavedCharts.push(
        <HexagonContainer key={"drag"} left={dragPoint.x} top={dragPoint.y} hex={dragHex} isDragHex />
      );

      miniHexGrid.push(
        <HexagonContainer
          key={"drag_mini"}
          left={dragPoint.x * miniWidthDelta + "px"}
          top={dragPoint.y * miniHeightDelta + "px"}
          hex={dragHex}
          isDragHex
          mType={mType}
          isMini
        />
      );
    }

    return isMini ? miniHexGrid : retSavedCharts;
  }
}
